import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import AssociatedAssetsItem from './associatedAssetsItem';
import AssociatedAssetOrganizationFilter from '../../assets/associatedAssetOrganizationFilter';
import AssociatedAssetTypeFilter from '../../assets/associatedAssetTypeFilter';
import ControlFilterSwitch from '../controls/controlFilterSwitch';
import Icon from '../containers/icon';
import entityComposition from '../classes/entityComposition';
class AssociatedAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectingAsset: false
    };
    this.controlFilterSwitch = null;
    this.filterChange = this.filterChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.setSelectingAssetFalse = this.setSelectingAsset.bind(this, false);
    this.setSelectingAssetTrue = this.setSelectingAsset.bind(this, true);
  }
  setSelectingAsset() {
    let doSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const selectingAsset = this.state.selectingAsset;
    if (selectingAsset !== doSelect) {
      this.setState({
        selectingAsset: doSelect
      });
    }

    // clear filters when modal unmounts
    if (selectingAsset && !doSelect) {
      const _this$props = this.props,
        indexQuery = _this$props.associatedAsset.indexQuery,
        serverFilter = _this$props.associatedAssetActions.serverFilter;
      serverFilter({}, indexQuery);
    }
  }
  filterChange(key, value) {
    const _this$props2 = this.props,
      indexQuery = _this$props2.associatedAsset.indexQuery,
      serverFilter = _this$props2.associatedAssetActions.serverFilter;
    const newFilters = _objectSpread(_objectSpread({}, indexQuery.filters), {}, {
      [key]: value
    });
    serverFilter(newFilters, indexQuery);
  }
  handleAdd(asset) {
    const onAdd = this.props.onAdd;
    this.setSelectingAssetFalse();
    onAdd(asset);
  }
  handleBack() {
    this.controlFilterSwitch.controlSwitch.switchControl();
  }
  render() {
    const _this$props3 = this.props,
      _this$props3$associat = _this$props3.associatedAsset,
      filters = _this$props3$associat.indexQuery.filters,
      loading = _this$props3$associat.loading,
      assets = _this$props3.assets,
      className = _this$props3.className,
      onChange = _this$props3.onChange,
      onRemove = _this$props3.onRemove;
    const selectingAsset = this.state.selectingAsset;
    const AssociatedAssetOrganizationFilterControl = /*#__PURE__*/React.createElement(AssociatedAssetOrganizationFilter, {
      filters: filters,
      onFilter: this.filterChange,
      onBack: this.handleBack,
      onAdd: this.handleAdd,
      assetsLoading: loading
    });
    const AssociatedAssetTypeFilterControl = /*#__PURE__*/React.createElement(AssociatedAssetTypeFilter, {
      filters: filters,
      onFilter: this.filterChange,
      onBack: this.handleBack,
      onAdd: this.handleAdd,
      assetsLoading: loading
    });
    const filterControls = [{
      label: 'Organizations',
      filterName: ['organization', 'facility', 'facilityGroup', 'facilityGroupArea'],
      control: AssociatedAssetOrganizationFilterControl,
      filters
    }, {
      label: 'Category / Type',
      filterName: ['assetCategoryName', 'assetType'],
      control: AssociatedAssetTypeFilterControl,
      filters
    }];
    return /*#__PURE__*/React.createElement("form", {
      className: "t-aa-form ".concat(className)
    }, /*#__PURE__*/React.createElement("h2", null, "Associated Assets"), /*#__PURE__*/React.createElement("hr", null), assets ? assets.map((item, index) => /*#__PURE__*/React.createElement(AssociatedAssetsItem, {
      asset: item,
      key: item.id,
      index: index,
      onChange: onChange,
      onRemove: onRemove
    })) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.setSelectingAssetTrue,
      className: "form-control addButton t-aa-add-associated-asset tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Entry"))), /*#__PURE__*/React.createElement(Modal, {
      className: "t-aa-form ".concat(className, "-modal"),
      isOpen: selectingAsset
    }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h2", null, "Select Asset"), /*#__PURE__*/React.createElement(ControlFilterSwitch, {
      filterControls: filterControls,
      ref: input => {
        this.controlFilterSwitch = input;
      }
    })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      className: "t-aa-button-cancel",
      onClick: this.setSelectingAssetFalse
    }, "Cancel"))));
  }
}
AssociatedAssets.defaultProps = {
  className: ''
};
AssociatedAssets.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  associatedAsset: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    loading: PropTypes.bool
  }).isRequired,
  associatedAssetActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  className: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export { AssociatedAssets as TestAssociatedAssets };
export default entityComposition(AssociatedAssets, ['associatedAsset']);